/* @flow */
import * as React from 'react';
import AnnouncementMessageListItem from './AnnouncementMessageListItem';
import ChatMessage, { ChatGapMessage } from 'entities/ChatMessage';
import GapMessageItem from './GapMessageItem';
import Message, { GapMessage } from 'entities/Message';
import MessageListTimeItem from './MessageListTimeItem';

import type { MessageBunch, MessageListItems } from 'chat/lib/MessageHistory';
import type { MessageType } from 'chat/lib/MessageInterfacePropType';
import type Group from 'entities/Group';

import './styles/MessagesList.scss';

export type Props = {
  disableReactionToggle?: boolean,
  group?: Group,
  items: MessageListItems,
  onGapVisible?: ?Function,
  subgroupRole?: string,
  isUnsubscribed: boolean,
  isGroupChat: boolean,
  threadUUID?: string,
};

class MessagesList extends React.PureComponent<Props> {
  static defaultProps = {
    isUnsubscribed: false,
    isGroupChat: false,
  };

  _hasErroredOnItemType: boolean;

  renderBunch(bunch: MessageBunch) {
    const { messages } = bunch;
    const { group, subgroupRole, disableReactionToggle, isGroupChat } = this.props;
    const itemKey = messages[0].getUuid();

    switch (bunch.messageType) {
      case 'broadcast':
      case 'message':
        return (
          <AnnouncementMessageListItem
            key={itemKey}
            group={group}
            subgroupRole={subgroupRole}
            messages={(messages: Array<Message | ChatMessage>)}
            isGroupChat={isGroupChat}
            disableReactionToggle={!!disableReactionToggle}
            showProfilePic
          />
        );
      case 'attachment':
      case 'text':
      case 'phone_call':
      case 'system':
      case 'gap':
        console.error('renderBunch received gap message');
        return undefined;
      default:
        console.error('Unknown Message Type: ' + bunch.messageType);
        return undefined;
    }
  }

  renderItem = (item: MessageType | MessageBunch | Date, index: number) => {
    if (item.messageType) {
      // $FlowFixMe not sure how to cast this
      const bunch: MessageBunch = item;
      return this.renderBunch(bunch);
    } else if (item instanceof ChatGapMessage || item instanceof GapMessage) {
      return (
        <GapMessageItem key={item.getUuid()} message={item} onVisible={this.props.onGapVisible} />
      );
    } else if (item instanceof Date) {
      return <MessageListTimeItem key={item.toUTCString()} date={item} />;
    } else {
      if (!this._hasErroredOnItemType) {
        console.warn('Unknown item type at index', index, item);
        console.error('DEBUG MessageList returning null for item');
        this._hasErroredOnItemType = true;
      }
      return null;
    }
  };

  render() {
    const { items } = this.props;

    return <ul className="MessagesList">{items.map(this.renderItem)}</ul>;
  }
}

export default MessagesList;
